module.exports = __webpack_public_path__ + "static/media/listOfApps.508df859.png";